// extracted by mini-css-extract-plugin
export default {"header":"style_header__9nsID","infosContainer":"style_infosContainer__AkcKA","name":"style_name__oe1W-","job":"style_job__wSyN6"};